import { login, getInfo, logout } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
    state : {
        token: getToken(),
        user: {},
    },

    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_USER: (state, user) => {
            state.user = user
        },
    },

    // # 函数执行方法
    actions: {
        // # 登录处理
        Login({ commit }, userInfo) {
            return new Promise((resolve, reject) => {
                login(userInfo.username, userInfo.password).then(res => {
                    // # 这里保存登录信息
                    //console.log(res)
                    setToken(res.token, false)
                    commit('SET_TOKEN', res.token)
                    setUserInfo(res.user, commit)
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // # 获取用户信息
        GetInfo({ commit }) {
            return new Promise((resolve, reject) => {
                getInfo().then(res => {
                  setUserInfo(res, commit)
                  resolve(res)
                }).catch(error => {
                  reject(error)
                })
            })
        },

        // # 退出登录
        Logout({ commit }) {
            return new Promise((resolve, reject) => {
              logout().then(res => {
                logOut(commit)
                resolve()
              }).catch(error => {
                logOut(commit)
                reject(error)
              })
            })
        },
    }
}

export const logOut = (commit) => {
    commit('SET_TOKEN', '')
    commit('SET_ROLES', [])
    removeToken()
}

export const setUserInfo = (user, commit) => {
    commit('SET_USER', user)
}

export default user